import {ITheme} from 'contexts/ThemeContext';
import {CreateResponsiveStyle, DEVICE_SIZES, maxSize, minSize} from 'rn-responsive-styles';

export default (props: ITheme) =>
  CreateResponsiveStyle({
    containerGeneral: {
      flex: 1,
      maxWidth: 420,
    },
    containerRegular: {
      flex: 1,
      maxWidth: 320,
    },
    textStyle: {
      marginTop: 24,
      fontSize: 14,
      ...props.typography.interMedium,
    },

    input: {
      height: 48,
      marginTop: 6,
      borderRadius: 8,
      paddingLeft: 14,
      backgroungColor: props.colors.white,
      fontSize: 16,
      boxShadow: `0px 1px 2px ${props.colors.shadowGrey}`,
      borderColor: props.colors.extraLight,
      borderWidth: 1,
      ...props.typography.interRegular,
    },
    
  },
  {
  },
  
  )();
